// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/font-awesome-4.7.0/css/font-awesome.css
// module id = 241
// module chunks = 1